import { getLabelMessage } from '@gef-ui/localization/messages';

import {
	isDateLessThanXYearsInPastExactlyFromChosenDay,
	isDateWithOrder,
	isFullySpecifiedDate,
} from 'app/forms/validations/common';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const CONTACT_HISTORY_FORM_NAME = 'contactHistory-filter';

const { product, policyNumber, contactType } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	product,
	service: 'service',
	serviceType: 'serviceType',
	contactType,
	result: 'result',
	policyNumber,
	dateFrom: 'dateFrom',
	dateTo: 'dateTo',
};

export default () => ({
	[FIELDS.product]: {
		deepPath: [FIELDS.product],
		validations: [],
	},
	[FIELDS.service]: {
		deepPath: [FIELDS.service],
		validations: [],
	},
	[FIELDS.serviceType]: {
		deepPath: [FIELDS.serviceType],
		validations: [],
	},
	[FIELDS.contactType]: {
		deepPath: [FIELDS.contactType],
		validations: [],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [],
	},
	[FIELDS.dateFrom]: {
		deepPath: [FIELDS.dateFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.dateFrom, toFieldName: FIELDS.dateTo }),
			isDateLessThanXYearsInPastExactlyFromChosenDay({
				yearsToSubtract: 1,
			}),
		],
	},
	[FIELDS.dateTo]: {
		deepPath: [FIELDS.dateTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.dateFrom, toFieldName: FIELDS.dateTo }),
		],
	},
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
});
